// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/mouse-pointer-click.js';

import { paths } from '../generated/mouse-pointer-click';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('mouse-pointer-click', Original, paths);
